var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraoverlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 95 34.2",
    style: {
      enableBackground: "new 0 0 95 34.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.8;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#182326;fill-opacity:0.85;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st3{fill:none;}\n\t.st4{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st5{fill:#FFFFFF;}\n\t.st6{mask:url(#mask-3_2_);}\n\t.st7{fill:#AFFF55;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#AFFF55;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "st1",
    d: "M0,0c7.3,20,25.8,34.2,47.5,34.2S87.7,20,95,0H0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    className: "st2",
    d: "M0,0c7.3,20,25.8,34.2,47.5,34.2S87.7,20,95,0H0z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-2_1_",
    x: 38.9,
    y: 9.9,
    className: "st3",
    width: 17.1,
    height: 14.5
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 38.9,
    y: 9.9,
    width: 17.1,
    height: 14.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 38.9,
    y: 9.9,
    width: 17.1,
    height: 14.5,
    id: "mask-3_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.9,
    y: 9.9,
    className: "st4",
    width: 17.1,
    height: 14.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-2_3_",
    x: 38.9,
    y: 9.9,
    className: "st5",
    width: 17.1,
    height: 14.5
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 42.2,
    cy: 15.2,
    rx: 0.9,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M51.4,12h2c1.5,0,2.7,1.2,2.7,2.6v7.1c0,1.4-1.2,2.6-2.7,2.6H41.6c-1.5,0-2.7-1.2-2.7-2.6v-7.1 c0-1.4,1.2-2.6,2.7-2.6h2c0,0,0.1,0,0.1-0.1l0.6-1.2c0.3-0.6,0.9-1,1.6-1h3.2c0.7,0,1.3,0.4,1.6,0.9L51.4,12 C51.3,12,51.4,12,51.4,12z M53.4,23.1c0.8,0,1.4-0.6,1.4-1.4h0v-7.1c0-0.8-0.6-1.4-1.4-1.4h-2c-0.5,0-1-0.3-1.2-0.7l-0.6-1.2 c-0.1-0.2-0.3-0.3-0.5-0.3h-3.2c-0.2,0-0.4,0.1-0.5,0.3l-0.6,1.2c-0.2,0.5-0.7,0.7-1.2,0.7h-2c-0.8,0-1.4,0.6-1.4,1.4v7.1 c0,0.8,0.6,1.4,1.4,1.4H53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M43.4,17.9c0-2.2,1.8-4,4.1-4s4.1,1.8,4.1,4c0,2.2-1.8,4-4.1,4S43.4,20.1,43.4,17.9z M44.6,17.9 c0,1.5,1.3,2.8,2.8,2.8c1.6,0,2.8-1.2,2.8-2.8c0-1.5-1.3-2.8-2.8-2.8C45.9,15.1,44.6,16.4,44.6,17.9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraoverlay);
export default __webpack_public_path__ + "static/media/cameraoverlay.a054e92a345734e05ddaaddff051df6f.svg";
export { ForwardRef as ReactComponent };